<div class="comms-list-container" (click)="selectCommIF()">
    <div class="top-row">
        <div class="name-container">
            <mat-icon
                data-cy="sys-status-comm-icon"
                svgIcon="status-indicator"
                [ngClass]="{
                    alarm_status: hasAlarms() && isReceivingData,
                    disconnected_status: !isReceivingData,
                    stable_status: !hasAlarms() && isReceivingData,
                }"
            />
            {{ "system-status.page-title.comms.long" | translate }}
            {{ " " + (index + 1) }}
        </div>
        <div class="location-container">
            <mat-icon svgIcon="more-info-status"> </mat-icon>
        </div>
    </div>
</div>
